module.exports = __webpack_public_path__ + "static/media/img-modal1.dcf64fa9.JPG";